(function ($) {

    $(document).ready(function () {

        // Filters by department
        $(".ct_teams .ct-btn").click(function() {
            // Change the button's state
            $(".ct_teams .ct-btn").removeClass("ct-active");
            $(this).addClass("ct-active");
            // Display/Hide the cards
            let department = $(this).data("department");
            $(".ct_teams .ct-teams-wrapper li").each((index, element) => {
                if ($(element).data("department-" + department)) {
                    $(element).fadeIn();
                }
                else {
                    $(element).fadeOut();
                }
            });
        });

        // When no filters are active, then activate the first one ("All")
        if ($(".ct_teams .ct-btn.active").length === 0) {
            $(".ct_teams .ct-btn").first().addClass("ct-active");
        }

        // Template: Slider
        var teamsslider = $('.ct_teams.slider:not(.admin_preview) .slider').each(function() {
            $(this).slick({
                'autoplay': true,
                'autoplaySpeed': 5000,
                'arrows': false,
                'fade': true,
                'dots': false,
                customPaging : function(slider, i) {
                    return '<i class="fas fa-circle"></i>';
                },
                'appendDots': $(this).closest('.ct_teams.slider').find('.slickNav'),
                'appendArrows': $(this).closest('.ct_teams.slider').find('.slickNav'),
                'prevArrow': '<i class="fal fa-chevron-left slick-prev"></i>',
                'nextArrow': '<i class="fal fa-chevron-right slick-next"></i>',
            });
        });

        // Display details on the panel at right
        function ctTeamsPanelDetails()
        {
            let teamsId = $(this).data("teams-id");
            let $this = $(this);
            let $panel = $(".ct-teams-panel-wrapper");
            if ($panel.length) {
                $(".ct-teams-image",         $panel).html( $(".ct-teams-image",         $this).html() );
                $(".ct-teams-name",          $panel).html( $(".ct-teams-name",          $this).html() );
                $(".ct-teams-function",      $panel).html( $(".ct-teams-function",      $this).html() );
                $(".ct-teams-email",         $panel).html( $(".ct-teams-email",         $this).html() );
                if ($(".ct-teams-social-medias", $this).data("social-medias-length") > 0) {
                    $(".ct-teams-social-medias", $panel).show()
                    $(".ct-teams-social-medias", $panel).html( $(".ct-teams-social-medias", $this).html() );
                }
                else {
                    $(".ct-teams-social-medias", $panel).hide()
                }
                $(".ct-teams-description",   $panel).html( $(".ct-teams-description",   $this).html() );
                $(document.body).addClass("ct-teams-panel-open");
            }
        }
        // Hide the panel details
        $(".ct-teams-panel-overlay, .close-team-panel ").click(function(event) {
            $(document.body).removeClass("ct-teams-panel-open");
        });
        // Move the panel directly inside HTML body (to have position aboslute regarding to full window)
        $(".ct-teams-panel-wrapper").appendTo("body");

        // Activate the "Panel details" on click on some elements
        $(".ct_teams.default .ct-teams-wrapper .ct-teams-card").click(ctTeamsPanelDetails);
        $(".ct_teams.slider .ct-teams-wrapper .ct-teams-card").click(ctTeamsPanelDetails);
    });

})(jQuery);
